module.exports = __webpack_public_path__ + "static/media/fi.3733753b.svg";